import WalletBased from "./WalletBased";

export default WalletBased;
